import React from 'react';
import MapTrifoldIcon from '@/components/icons/MapTrifoldIcon/MapTrifoldIcon';
import UsersFourIcon from '@/components/icons/UsersFourIcon/UsersFourIcon';
import AnchorIcon from '@/components/icons/AnchorIcon/AnchorIcon';
import ChampagneIcon from '@/components/icons/ChampagneIcon/ChampagneIcon';
import SnowflakeIcon from '@/components/icons/SnowflakeIcon/SnowflakeIcon';
import GlobeIcon from '@/components/icons/GlobeIcon/GlobeIcon';
import { SVGIconType } from '@/components/icons/svg-icon-types';

// +-------------+-------------------+-------------------------+
// | travel_type | slug              | title                   |
// +-------------+-------------------+-------------------------+
// |        NULL | black-week        | Black Week              |
// |        NULL | grupos-exclusivos | Grupos Exclusivos       |
// |           1 | personalizadas    | Viagens Personalizadas  |
// |           2 | lua-de-mel        | Viagens de Lua de Mel   |
// |           3 | extensao          | Pacote de Extensão      |
// |           4 | grupo             | Viagem em Grupo         |
// |           5 | experiencia       | Pacotes de Experiência  |
// |           6 | cruzeiros         | Cruzeiros               |
// |           7 | reveillon         | Réveillon               |
// |           8 | ski               | Ski                   |
// +-------------+-------------------+-------------------------+

export interface TravelTypeIconProps extends SVGIconType {
  id?: number | string;
}

const TravelTypeIcon = ({ id, ...props }: TravelTypeIconProps) => {
  switch (id) {
    case 1:
    case 'personalizadas':
      return <MapTrifoldIcon {...props} />;
    case 4:
    case 'grupo':
      return <UsersFourIcon {...props} />;
    case 6:
    case 'cruzeiros':
      return <AnchorIcon {...props} />;
    case 7:
    case 'reveillon':
      return <ChampagneIcon {...props} />;
    case 8:
    case 'esqui':
    case 'ski':
      return <SnowflakeIcon {...props} />;

    // Fallback icon
    default:
      return <GlobeIcon {...props} />;
  }
};

export default TravelTypeIcon;
